document.addEventListener('DOMContentLoaded', function () {
    initFeaturedProductsSliders();
});

window.addEventListener('load', function () {
    initFeaturedProductsSliders();
});

function clampFeaturedPerPage(value, slideCount) {
    const parsed = parseInt(value, 10);
    const perPage = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
    return Math.max(1, Math.min(perPage, Math.max(1, slideCount)));
}

function prepareFeaturedSliderOptions(options, slideCount) {
    const next = Object.assign({}, options);
    next.perPage = clampFeaturedPerPage(next.perPage, slideCount);
    next.breakpoints = Object.assign({}, next.breakpoints || {});

    Object.keys(next.breakpoints).forEach(function (bp) {
        next.breakpoints[bp] = Object.assign({}, next.breakpoints[bp]);
        if (next.breakpoints[bp].perPage) {
            next.breakpoints[bp].perPage = clampFeaturedPerPage(next.breakpoints[bp].perPage, slideCount);
        }
    });

    next.arrows = !!(next.arrows && slideCount > next.perPage);
    next.pagination = !!(next.pagination && slideCount > next.perPage);
    next.type = 'slide';
    next.rewind = slideCount > next.perPage;
    next.drag = slideCount > next.perPage;

    return next;
}

function initFeaturedProductsSliders() {
    const sliders = document.querySelectorAll('.featured-products .splide');

    sliders.forEach(function (slider) {
        if (slider.classList.contains('is-initialized') || typeof Splide === 'undefined') {
            return;
        }

        const slideCount = slider.querySelectorAll('.splide__slide').length;

        let options = {
            type: 'slide',
            rewind: true,
            omitEnd: true,
            perPage: 4,
            perMove: 1,
            gap: '2rem',
            arrows: true,
            pagination: true,
            autoplay: false,
            interval: 3000,
            pauseOnHover: true,
            drag: true,
            breakpoints: {
                1199: {
                    perPage: 3,
                    gap: '1.5rem'
                },
                991: {
                    perPage: 2,
                    gap: '1.5rem'
                },
                576: {
                    perPage: 2,
                    gap: '0.625rem'
                }
            }
        };

        if (slider.dataset.splide) {
            try {
                options = Object.assign(options, JSON.parse(slider.dataset.splide));
            } catch (parseError) {
                // Keep defaults when custom options are invalid.
            }
        }

        const splide = new Splide(slider, prepareFeaturedSliderOptions(options, slideCount));
        splide.mount();
        slider.classList.add('is-initialized');
        slider.classList.toggle('is-all-visible', slideCount <= splide.options.perPage);
    });
}
